import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import axios from 'utils/axios';
import { QuotationProps } from 'types/props-obj/QuotationProps';
import { openSnackbar } from './snackbar';
const initialState: QuotationProps = {
    apiEndPoint: "quotation",
    isOpen: false,
    pageNumber:1,
    last_page:1,
    pageLimit:50,
    current_page:1,
    total:0,
    list: [],
    item:null,
    error: null,
    alertPopup: false
  };
const quotation = createSlice({
    name: 'quotation',
    initialState,
    reducers: {
      setError(state, action) {
        state.error = action.payload?.message;
      },
      setPageNumber(state, action) {
        state.pageNumber = action.payload;
      },
      setPageLimit(state, action) {
        state.pageLimit = action.payload;
      },
      // get all quotation list
      getList(state, action) {
        state.list.push(action.payload);
        const replaceList = state.list.filter((liste) => liste.id != 0);
        state.list = replaceList;
      },
      alertPopupToggle(state, action) {
        state.alertPopup = action.payload.alertPopup;
      },
      
      // get quotation details
      setQuotation(state, action) {
        state.item = action.payload;
      },
  
      // GET Quotations
      setQuotationsSuccess(state, action) {
          state.list = action.payload.data;
          state.current_page=action.payload.current_page;
          state.last_page=action.payload.last_page;
          state.total=action.payload.total
      },

    // ADD Quotation
    addQuotationSuccess(state, action) {
      state.list = [...state.list,action.payload];      
    },

    // EDIT Quotation
    editQuotationSuccess(state, action) {
      var foundIndex = state.list.findIndex(x => x.id == action.payload.id);
      state.list[foundIndex] = action.payload;
      state.item = action.payload;
    },

    deleteQuotationSuccess(state, action) {
      const deleteData = state.list.filter((item) => item.id !== action.payload);
      state.list = deleteData;
    },
    
  
    }
  });
  export default quotation.reducer;
  export const {    getList,setPageNumber,setPageLimit,alertPopupToggle,setQuotation} = quotation.actions;

  export function getQuotations(params:any={}) {
    return async () => {
      try {
        const response = await axios.get(initialState.apiEndPoint,{params:params});
        dispatch(quotation.actions.setQuotationsSuccess(response.data));
      } catch (error:any) {
        // dispatch(quotation.actions.setError(error));
        // dispatch(openSnackbar({open: true,message: 'Too many requests',variant: 'alert',alert: {color: 'error'},close: false}));
      }
    };
  }

  export function getQuotation(id: number | undefined) {
    return async () => {
      try {
        const response = await axios.get([initialState.apiEndPoint,  id].join('/'));
        dispatch(quotation.actions.setQuotation(response.data));
      } catch (error:any) {
        dispatch(quotation.actions.setError(error));
        dispatch(openSnackbar({open: true,message: 'Something went wrong',variant: 'alert',alert: {color: 'error'},close: false}));
      }
    };
  }

  export function addQuotation(ls:any) {
    return async () => {
      try {        
        const response = await axios.post(initialState.apiEndPoint, ls);
        dispatch(quotation.actions.addQuotationSuccess(response.data));
      } catch (error:any) {
        dispatch(quotation.actions.setError(error));
        dispatch(openSnackbar({open: true,message: 'Unable to Add Quotation',variant: 'alert',alert: {color: 'error'},close: false}));
      }
    };
  }
  
  export function editQuotation(id: number | undefined,ls: any) {
    return async () => {
      try {
        const response = await axios.put([initialState.apiEndPoint,  id].join('/'), ls);
        dispatch(quotation.actions.editQuotationSuccess(response.data));
      } catch (error:any) {
        dispatch(quotation.actions.setError(error));
        dispatch(openSnackbar({open: true,message:'Unable to Update Quotation',variant: 'alert',alert: {color: 'error'},close: false}));
      }
    };
  }

  export function deleteQuotation(id: number | undefined) {
    return async () => {
      try {
        await axios.delete([initialState.apiEndPoint,  id].join('/'));
        dispatch(quotation.actions.deleteQuotationSuccess(id));
      } catch (error:any) {
        dispatch(quotation.actions.setError(error));
        dispatch(openSnackbar({open: true,message: 'Unable to Delete Quotation',variant: 'alert',alert: {color: 'error'},close: true}));
      }
    };
  }


   export function sendQuotation(id: number | undefined,ls: any) {
    return async () => {
      try {
        const response = await axios.post(['send-quotation',  id].join('/'), ls,{headers:{'Content-Type': 'multipart/form-data'}});
        dispatch(quotation.actions.editQuotationSuccess(response.data));
      } catch (error:any) {
        dispatch(quotation.actions.setError(error));
        dispatch(openSnackbar({open: true,message: error.message,variant: 'alert',alert: {color: 'error'},close: false}));
      }
    };
  }
